<template>
    <modal v-model="show" :title="title" :submit="add" :disabled="!isSelected(items)" :cancel="cancel">
        <!-- Teams -->
        <template slot="body" v-if="type === 'teams'">
            <fg-input :label="$t('Teams')" name="teams" required>
                <input-picker v-model="items" multiple :filter="teamsFilter" data-type="team"
                              :label="$t('Teams')"/>
            </fg-input>
        </template>
        <!---->
        <!-- Category -->
        <template slot="body" v-if="type === 'questions'">
            <fg-input :label="$t('Category')">
                <el-select filterable
                           class="select-primary"
                           size="large"
                           v-model="category"
                           :placeholder="$t('Category')">
                    <el-option v-for="category in categories"
                               :value="category._id"
                               :label="languageFormatter(category.title)"
                               :key="category._id">
                    </el-option>
                </el-select>
            </fg-input>
        </template>
        <!---->
        <!-- Questions -->
        <template slot="body" v-if="type === 'questions' && category">
            <fg-input :label="$t('Questions')">
                <el-select multiple
                           filterable
                           class="select-primary"
                           size="large"
                           v-model="items"
                           value-key="_id"
                           :placeholder="$t('Questions')">
                    <el-option v-for="question in filtered(value.questions, questions)"
                               :value="question"
                               :label="languageFormatter(question.title)"
                               :key="question._id">
                    </el-option>
                </el-select>
            </fg-input>
        </template>
        <!---->
    </modal>
</template>

<script>
  import { Input, Button, Select, Option, Checkbox } from 'element-ui'
  import InputPicker from '../../Components/InputPicker'
  import Modal from '../../Components/BasicModal'
  import isEmpty from 'lodash/isEmpty'
  import findIndex from 'lodash/findIndex'
  import filter from 'lodash/filter'
  import QuestionModel from 'src/store/models/Question'
  import QuestionCategoryModel from 'src/store/models/QuestionCategory'

  export default {
    name: 'QuestionnaireModal',
    components: {
      [Input.name]: Input,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      InputPicker
    },
    props: {
      value: {
        type: Object
      },
      show: {
        type: Boolean
      },
      type: {
        type: String
      },
      cancel: {
        type: Function
      }
    },
    data () {
      return {
        items: [],
        title: '',
        category: null
      }
    },
    async mounted () {
      await this.fetchQuestionCategory()
    },
    methods: {
      add: function () {
        const {type, items} = this
        const newValue = this.value
        items.forEach(item => {
          newValue[type].push(item)
        })
        this.$emit('input', this.newValue)
        this.cancel()
      },
      isSelected: function (item) {
        return !isEmpty(item)
      },
      languageFormatter: function (value) {
        return this.$options.filters.languageString(value)
      },
      filtered: function (ids, items) {
        return filter(items, item => findIndex(ids, ({_id}) => _id === item._id) === -1)
      },
      teamsFilter: function (item) {
        return findIndex(this.value.teams, v => v._id === item._id) === -1
      },
      fetchQuestionCategory: async function () {
        try {
          await QuestionCategoryModel.api().get('/questionCategory', { dataKey: 'items' })
        } catch (e) {console.log('e', e)}
      },
      fetchQuestions: async function (categoryId) {
        try {
          await QuestionModel.query().with('category').deleteAll()
          await QuestionModel.api().get(`/questionCategory/${categoryId}/question`, { dataKey: 'items' })
        } catch (e) {console.log('e', e)}
      }
    },
    watch: {
      type (val) {
        this.items = []
        switch (val) {
          case 'teams':
            this.title = this.$t('Add Teams')
            break
          case 'questions':
            this.title = this.$t('Add Questions')
            break
          default:
            this.title = ''
            break
        }
      },
      category (val) {
        if (val) {
          this.fetchQuestions(val)
        }
      }
    },
    computed: {
      categories: () => QuestionCategoryModel.all(),
      questions: () => QuestionModel.query().with('category').all()
    }

  }
</script>
